import { Asset } from '@/api/generatedApi';
import { Box } from '@mui/material';
import { createUseStyles } from '@/services/createUseStyles';
import { SimpleTreeView } from '@mui/x-tree-view';
import { DependencyTreeView } from './DependencyTreeView';
import { TreeItemWrapper } from './DependencyTreeView';

const useStyles = createUseStyles({
  DependencyTreeContainer: {
    overflow: 'auto',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
    scrollbarWidth: 'none',
    msOverflowStyle: 'none',
  },
});

export interface DependencyTreeContainerProperties {
  asset: Asset;
  onTreeItemClick?: (itemId: string) => void;
}

export const DependencyTreeContainer = ({ asset, onTreeItemClick }: DependencyTreeContainerProperties) => {
  const c = useStyles();

  return (
    <Box data-cy='assembly-tree-wrapper' className={c.DependencyTreeContainer}>
      <SimpleTreeView key={asset.id} aria-label='assembly tree' data-cy='assembly-tree'>
        <TreeItemWrapper id={asset.id} path={asset.path} hasMissingChildDependencies={asset.isMissingDependencies}>
          <DependencyTreeView asset={asset} onTreeItemClick={onTreeItemClick} />
        </TreeItemWrapper>
      </SimpleTreeView>
    </Box>
  );
};
